import validationRoute from "@/guard/routeGuard.js";
import store from "@/store/index";
import PageNotFound from "@/views/PageNotFound.vue";
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

export function routesExceptions() {
  return ["dashboard", "account", "view_term"];
}

const routes = [
  {
    path: "/",
    name: "Login",
    completeName: "Login",
    template: false,
    component: () => import("@/components/modules/login/Login.vue"),
  },
  {
    path: "/acesso-rapido",
    name: "Acesso rápido",
    completeName: "Acesso rápido",
    groupBy: "",
    template: true,
    permission: "dashboard",
    beforeEnter: validationRoute,
    component: () =>
      import("@/components/modules/quick-access/QuickAccess.vue"),
  },
  {
    path: "/documentos",
    name: "Documentos",
    completeName: "Lista de documentos",
    groupBy: "Cadastros básicos",
    template: true,
    permission: "cad_documents",
    beforeEnter: validationRoute,
    component: () => import("@/components/modules/documents/Grid.vue"),
  },
  {
    path: "/pacientes",
    name: "Pacientes",
    completeName: "Lista de pacientes",
    groupBy: "Cadastros básicos",
    template: true,
    permission: "cad_patient",
    beforeEnter: validationRoute,
    component: () => import("@/components/modules/patients/Grid.vue"),
  },
  {
    path: "/pacientes/paciente",
    name: "Paciente",
    completeName: "Paciente",
    template: true,
    permission: "cad_patient",
    beforeEnter: validationRoute,
    component: () =>
      import("@/components/modules/patients/patient/Patient.vue"),
  },
  {
    path: "/perfis",
    name: "Perfis",
    completeName: "Lista de perfis",
    groupBy: "Cadastros básicos",
    template: true,
    permission: "list_perfil",
    beforeEnter: validationRoute,
    component: () => import("@/components/modules/profiles/Profiles.vue"),
  },
  {
    path: "/perfil/permissoes",
    name: "Lista de permissões",
    completeName: "Lista de permissões",
    template: true,
    permission: "list_perfil",
    beforeEnter: validationRoute,
    component: () => import("@/components/modules/profiles/Modules.vue"),
  },
  {
    path: "/procedimentos-protocolos/ambulatorial",
    name: "Procedimentos/Protocolos",
    completeName: "Lista de procedimentos/protocolos - Ambulatorial",
    groupBy: "Cadastros básicos",
    template: true,
    permission: "procedures_protocols_screen",
    beforeEnter: validationRoute,
    component: () =>
      import(
        "@/components/modules/procedures-protocols/outpatient/Outpatient.vue"
      ),
  },
  {
    path: "/procedimentos-protocolos/ppp-imagem",
    name: "Procedimentos/Protocolos Exames de imagem",
    completeName: "Lista de procedimentos/protocolos - Exames de imagem",
    groupBy: "",
    template: true,
    permission: "procedures_protocols_screen",
    beforeEnter: validationRoute,
    component: () =>
      import("@/components/modules/procedures-protocols/ppp/Exams.vue"),
  },
  {
    path: "/profissionais",
    name: "Profissionais",
    completeName: "Lista de profissionais",
    groupBy: "Cadastros básicos",
    template: true,
    permission: "list_professionals",
    beforeEnter: validationRoute,
    component: () => import("@/components/modules/professionals/Grid.vue"),
  },
  {
    path: "/profissionais/profissional",
    name: "Profisisonal",
    completeName: "Profisisonal",
    template: true,
    permission: "cad_professionals",
    beforeEnter: validationRoute,
    component: () =>
      import(
        "@/components/modules/professionals/professional/Professional.vue"
      ),
  },
  {
    path: "/termos",
    name: "Termos",
    completeName: "Lista de termos",
    groupBy: "Cadastros básicos",
    template: true,
    permission: "list_protocol",
    beforeEnter: validationRoute,
    component: () => import("@/components/modules/terms/Grid.vue"),
  },
  {
    path: "/unidades",
    name: "Unidades",
    completeName: "Lista de unidades",
    groupBy: "Cadastros básicos",
    template: true,
    permission: "cad_unities",
    beforeEnter: validationRoute,
    component: () => import("@/components/modules/unities/Grid.vue"),
  },
  {
    path: "/unidade",
    name: "Unidade",
    completeName: "Unidade",
    template: true,
    permission: "cad_unities",
    beforeEnter: validationRoute,
    component: () => import("@/components/modules/unities/unity/Unity.vue"),
  },
  {
    path: "/unidade/abrangencias/rede-abrangencia",
    name: "Rede de abrangência",
    completeName: "Rede de abrangência",
    template: true,
    permission: "cad_unities",
    beforeEnter: validationRoute,
    component: () =>
      import("@/components/modules/unities/coverages/network/Coverages.vue"),
  },
  {
    path: "/unidade/abrangencias/distritos-sanitarios",
    name: "Distritos sanitários",
    completeName: "Distritos sanitários",
    template: true,
    permission: "cad_unities",
    beforeEnter: validationRoute,
    component: () =>
      import("@/components/modules/unities/coverages/districts/Grid.vue"),
  },
  {
    path: "/unidade/ppp",
    name: "PPP",
    completeName: "Controle de solicitação de Exames de imagem",
    template: true,
    permission: "cad_unities",
    beforeEnter: validationRoute,
    component: () => import("@/components/modules/unities/ppp/Grid.vue"),
  },
  {
    path: "/unidade/procedimentos",
    name: "Procedimentos vinculados a unidade",
    completeName: "Lista de procedimentos vinculados a unidade",
    template: true,
    permission: "cad_unities",
    beforeEnter: validationRoute,
    component: () =>
      import("@/components/modules/unities/procedures/Procedures.vue"),
  },
  {
    path: "/usuarios",
    name: "Usuários",
    completeName: "Lista de usuários",
    groupBy: "Cadastros básicos",
    template: true,
    permission: "list_perfil",
    beforeEnter: validationRoute,
    component: () => import("@/components/modules/users/Grid.vue"),
  },
  {
    path: "/solicitacao",
    name: "Nova solicitação",
    completeName: "Solicitação | Selecionar paciente",
    groupBy: "",
    template: true,
    permission: "cad_solicitation_screen",
    beforeEnter: validationRoute,
    component: () => import("@/components/modules/patients/Grid.vue"),
  },
  {
    path: "/solicitacao/paciente",
    name: "Solicitação | Dados do paciente",
    completeName: "Solicitação | Dados do paciente",
    template: true,
    permission: "cad_solicitation_screen",
    beforeEnter: validationRoute,
    component: () =>
      import("@/components/modules/patients/patient/Patient.vue"),
  },
  {
    path: "/solicitacoes",
    name: "Solicitações",
    completeName: "Lista de solicitações",
    groupBy: "",
    template: true,
    permission: "solicitations_screen",
    beforeEnter: validationRoute,
    component: () => import("@/components/modules/solicitations/Grid.vue"),
  },
  {
    path: "/solicitacao/cadastrar-solicitacao",
    name: "Solicitação | Cadastrar solicitação",
    completeName: "Solicitação | Cadastrar solicitação",
    template: true,
    permission: "cad_solicitation",
    beforeEnter: validationRoute,
    component: () =>
      import(
        "@/components/modules/solicitations/solicitation/Solicitation.vue"
      ),
  },
  {
    path: "/solicitacao/atualizar-solicitacao",
    name: "Solicitação | Atualizar solicitação",
    completeName: "Solicitação | Atualizar solicitação",
    groupBy: "",
    template: true,
    permission: "cad_solicitation",
    beforeEnter: validationRoute,
    component: () =>
      import(
        "@/components/modules/solicitations/solicitation/Solicitation.vue"
      ),
  },
  {
    path: "/solicitacao/avaliar",
    name: "Avaliar solicitação",
    completeName: "Avaliar solicitação",
    groupBy: "",
    template: true,
    permission: "update_assessments",
    beforeEnter: validationRoute,
    component: () =>
      import("@/components/modules/solicitations/assessment/Assessment.vue"),
  },
  {
    path: "/avaliacoes",
    name: "Solicitações avaliadas",
    completeName: "Lista de solicitações avaliadas da unidade",
    groupBy: "",
    template: true,
    permission: "assessments_screen",
    beforeEnter: validationRoute,
    component: () => import("@/components/modules/assessments/Grid.vue"),
  },
  {
    path: "/mapa-agenda",
    name: "Mapa de agenda",
    completeName: "Mapa de agenda",
    groupBy: "",
    template: true,
    permission: "schedules_map_screen",
    beforeEnter: validationRoute,
    component: () => import("@/components/modules/schedules/Schedules.vue"),
  },
  {
    path: "/regular-pacientes",
    name: "Regular pacientes",
    completeName: "Regular pacientes",
    groupBy: "",
    template: true,
    permission: "list_regulate_patient",
    beforeEnter: validationRoute,
    component: () => import("@/components/modules/regulate-patients/Grid.vue"),
  },
  {
    path: "/regular-paciente",
    name: "Regular paciente",
    completeName: "Regular paciente",
    groupBy: "",
    template: true,
    permission: "list_schedule",
    beforeEnter: validationRoute,
    component: () =>
      import("@/components/modules/regulate-patients/regulate/Index.vue"),
  },
  {
    path: "/pacientes-regulados",
    name: "Pacientes regulados",
    completeName: "Lista de pacientes regulados",
    groupBy: "Atendimentos",
    template: true,
    permission: "list_patient_regulated",
    beforeEnter: validationRoute,
    component: () => import("@/components/modules/regulated-patients/Grid.vue"),
  },
  {
    path: "/faq",
    name: "Perguntas frequentes",
    completeName: "Lista de perguntas frequentes",
    groupBy: "",
    template: true,
    permission: "list_perfil",
    beforeEnter: validationRoute,
    component: () => import("@/components/modules/help/faq/FaqList.vue"),
  },
  {
    path: "/perguntas-frequentes",
    name: "Perguntas Frequentes",
    completeName: "Perguntas Frequentes",
    template: false,
    component: () => import("@/components/modules/help/faq/FaqView.vue"),
  },
  {
    path: "/logs",
    name: "Logs de usuários",
    completeName: "Logs de usuários",
    groupBy: "",
    template: true,
    permission: "list_logs",
    beforeEnter: validationRoute,
    component: () => import("@/components/modules/logs/Logs.vue"),
  },
  {
    path: "/procedimentos-protocolos/unacon",
    name: "Procedimentos/Procolocos UNACON",
    completeName: "Lista de procedimentos/procolocos - UNACON/CACON",
    groupBy: "",
    template: true,
    permission: "procedures_protocols_screen",
    beforeEnter: validationRoute,
    component: () =>
      import("@/components/modules/procedures-protocols/oncology/Oncology.vue"),
  },
  {
    path: "/procedimentos-protocolos/ambulatorial-egresso",
    name: "Procedimentos/Procolocos Ambulatorial Egresso",
    completeName: "Lista de procedimentos/procolocos - Ambulatorial egresso",
    groupBy: "",
    template: true,
    permission: "procedures_protocols_screen",
    beforeEnter: validationRoute,
    component: () =>
      import("@/components/modules/procedures-protocols/egress/Egress.vue"),
  },
  {
    path: "/usuario",
    name: "Usuário",
    completeName: "Cadastrar/atualizar usuário",
    groupBy: "",
    template: true,
    permission: "list_perfil",
    beforeEnter: validationRoute,
    component: () => import("@/components/modules/users/User.vue"),
  },
  {
    path: "/decisoes-judiciais",
    name: "Decisões judiciais",
    completeName: "Lista de decisões judiciais",
    groupBy: "",
    template: true,
    permission: "cad_judicial_decision",
    beforeEnter: validationRoute,
    component: () => import("@/components/modules/judicial-decisions/Grid.vue"),
  },
  {
    path: "/decisao-judicial",
    name: "Decisão judicial",
    completeName: "Decisão Judicial",
    groupBy: "",
    template: true,
    permission: "cad_judicial_decision",
    beforeEnter: validationRoute,
    component: () =>
      import("@/components/modules/judicial-decisions/JudicialDecision.vue"),
  },
  {
    path: "/lista-protocolos",
    name: "Lista de Protocolos e Orientações",
    completeName: "Lista de Protocolos e Orientações",
    groupBy: "",
    template: true,
    permission: "list_protocol",
    beforeEnter: validationRoute,
    component: () =>
      import("@/components/modules/procedures-protocols/list/Protocols.vue"),
  },
  {
    path: "/relatorios",
    name: "Relatórios",
    completeName: "Relatórios",
    groupBy: "",
    template: true,
    permission: "display_reports_screen",
    beforeEnter: validationRoute,
    component: () => import("@/components/modules/reports/excel/Excel.vue"),
  },
  {
    path: "/cirurgias-eletivas/procedimentos-vinculados",
    name: "Procedimentos vinculados",
    completeName: "Lista de procedimentos vinculados",
    groupBy: "Cirurgias eletivas",
    template: true,
    permission: "cad_unities", // ALTERAR
    beforeEnter: validationRoute,
    component: () =>
      import(
        "@/components/modules/elective-surgeries/binded-procedures/Grid.vue"
      ),
  },
  {
    path: "/cirurgias-eletivas/credenciamentos",
    name: "Credenciamento",
    completeName: "Lista de credenciamento",
    groupBy: "Cirurgias eletivas",
    template: true,
    permission: "cad_unities", // ALTERAR
    beforeEnter: validationRoute,
    component: () =>
      import("@/components/modules/elective-surgeries/accreditations/Grid.vue"),
  },
  {
    path: "/cirurgias-eletivas/credenciamento/procedimentos",
    name: "Cirurgias Eletivas > Credenciamento - Procedimentos",
    completeName: "Lista de procedimentos do credenciamento",
    groupBy: "",
    template: true,
    permission: "cad_unities", // ALTERAR
    beforeEnter: validationRoute,
    component: () =>
      import(
        "@/components/modules/elective-surgeries/accreditations/procedures/Grid.vue"
      ),
  },
  {
    path: "/termos/novo",
    name: "Termo",
    completeName: "Termos > Novo termo",
    groupBy: "",
    template: true,
    permission: "list_protocol",
    beforeEnter: validationRoute,
    component: () => import("@/components/modules/terms/term/Term.vue"),
  },
  {
    path: "/visualizar-termo",
    name: "Visualizar Termo",
    completeName: "Visualizar termo",
    groupBy: "",
    template: false,
    permission: "view_term",
    beforeEnter: validationRoute,
    component: () => import("@/components/modules/terms/term/View.vue"),
  },
  {
    path: "/municipios",
    name: "Localização - Municípios",
    completeName: "Lista de municípios",
    groupBy: "Cadastros básicos",
    template: true,
    permission: "cad_county",
    beforeEnter: validationRoute,
    component: () => import("@/components/modules/municipalities/Grid.vue"),
  },
  {
    path: "/bairros",
    name: "Localização - Bairros",
    completeName: "Lista de bairros de Salvador",
    groupBy: "Cadastros básicos",
    template: true,
    permission: "cad_district",
    beforeEnter: validationRoute,
    component: () => import("@/components/modules/neighborhoods/Grid.vue"),
  },
  {
    path: "/pacientes-regulados-unacon-cacon",
    name: "UNACON/CACON",
    completeName: "Lista de pacientes regulados - UNACON/CACON",
    groupBy: "Atendimentos",
    template: true,
    permission: "list_patient_regulated",
    beforeEnter: validationRoute,
    component: () =>
      import("@/components/modules/regulated-patients/unacon-cacon/Grid.vue"),
  },
  { path: "*", template: false, component: PageNotFound },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // redefine o status dos modais do sistema
  store.state.modals.defaultModalData.status = false;

  const saveProcess = localStorage.getItem("saveProcess");

  if (saveProcess) {
    next();
    localStorage.removeItem("saveProcess");
    return;
  }

  if (
    (from.path === "/pacientes/paciente" &&
      to.path !== "/pacientes/paciente") ||
    (from.path === "/solicitacao/paciente" &&
      to.path !== "/solicitacao/paciente") ||
    (from.path === "/solicitacao/cadastrar-solicitacao" &&
      to.path !== "/solicitacao/cadastrar-solicitacao") ||
    (from.path === "/solicitacao/atualizar-solicitacao" &&
      to.path !== "/solicitacao/atualizar-solicitacao") ||
    (from.path === "/solicitacao/avaliar" && to.path !== "/solicitacao/avaliar")
  ) {
    const confirmNavigation = window.confirm(
      `Você está saindo de ${from.name} para ${to.name}?
Ao fechar a tela, os dados não salvos serão perdidos. 
    
Deseja sair da tela?`
    );

    if (confirmNavigation) {
      next();
      localStorage.removeItem("saveProcess");
    } else {
      next(false);
    }
  } else {
    next();
  }
});

export default router;
